import React, { ReactNode } from "react"

type ErrorBoundaryProps = {
    children: ReactNode
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
    const [hasError, setHasError] = React.useState(false)
    const [error, setError] = React.useState<unknown>(null)

    // This inner component uses the legacy ErrorBoundary class to catch errors
    class InnerBoundary extends React.Component<{ children: ReactNode }> {
        componentDidCatch(error: unknown, errorInfo: unknown) {
            setHasError(true)
            setError(error)
            // Optionally log errorInfo
            console.error("React ErrorBoundary caught:", error, errorInfo)
        }
        render() {
            return this.props.children
        }
    }

    if (hasError) {
        return <div>Something went wrong: {String(error)}</div>
    }

    return <InnerBoundary>{children}</InnerBoundary>
}